import React, { memo } from 'react';
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';
//styles
import { StyledSVG } from './styles';

//types
import { IconProps } from './types';
import { Theme } from '@nykaa/ui-components/themes/types';

const DEFAULT_DOT_SIZE = 6;
function Video({ className, fillOpacity, size = DEFAULT_DOT_SIZE }: IconProps) {
  const theme: Theme = useTheme();

  return (
    <StyledSVG
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-test="video-dot"
      size={size}
      marginRight={size - 1}
    >
      <path
        d="M8 1C4.13444 1 1 4.13444 1 8C1 11.8656 4.13444 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13444 11.8656 1 8 1ZM10.7533 8.27222L6.54556 10.8622C6.32778 10.9944 6.04778 10.8389 6.04778 10.59V5.41C6.04778 5.15333 6.32778 4.99778 6.54556 5.13778L10.7533 7.72778C10.9633 7.85222 10.9633 8.14778 10.7533 8.27222Z"
        fill={theme.colors.primary}
        className={className}
        fillOpacity={fillOpacity}
      />
    </StyledSVG>
  );
}

export default memo(Video);
